import { render, staticRenderFns } from "./AddFollowSale.vue?vue&type=template&id=11eda723&scoped=true"
import script from "./AddFollowSale.vue?vue&type=script&lang=js"
export * from "./AddFollowSale.vue?vue&type=script&lang=js"
import style0 from "./AddFollowSale.vue?vue&type=style&index=0&id=11eda723&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11eda723",
  null
  
)

export default component.exports